<div class="form-options" fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="center flex-start">
  <button *ngIf="!withoutEdit" type="button" (click)="onClickSave()" class="nav-button save-button" [disabled]="form.pristine">
    <fa-icon [icon]="saveIcon"></fa-icon>
  </button>
  <button *ngIf="!withoutDelete" type="button" (click)="onClickDelete()" class="nav-button">
    <fa-icon [icon]="deleteIcon"></fa-icon>
  </button>
</div>
